(function () {
  document.addEventListener('DOMContentLoaded', function () {
    function showCartToast() {
      var t = document.getElementById('cbj-cart-toast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'cbj-cart-toast';
        t.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%) translateY(16px);background:#1a1a1a;color:#fff;padding:10px 22px;border-radius:20px;font-size:12px;opacity:0;transition:opacity .25s,transform .25s;z-index:9999;white-space:nowrap;pointer-events:none';
        document.body.appendChild(t);
      }
      t.textContent = 'カートに追加しました';
      t.style.opacity = '1';
      t.style.transform = 'translateX(-50%) translateY(0)';
      clearTimeout(t._timer);
      t._timer = setTimeout(function () {
        t.style.opacity = '0';
        t.style.transform = 'translateX(-50%) translateY(16px)';
      }, 2500);
    }

    function makeCartBtn(cls) {
      var btn = document.createElement('span');
      btn.className = cls;
      btn.textContent = 'カートに追加';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-variant-id]');
        var variantId = card ? parseInt(card.dataset.variantId) : null;
        if (!variantId) { if (card) window.location.href = card.href; return; }
        btn.textContent = '追加中…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { window.location.href = card.href; return; }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var el = document.querySelector('.cart-count');
            if (el) el.textContent = c.item_count;
          });
          showCartToast();
          btn.textContent = 'カートに追加';
        })
        .catch(function () { window.location.href = '/cart'; });
      });
      return btn;
    }

    document.querySelectorAll('.product-card').forEach(function (card) {
      var body = card.querySelector('.product-card-body');
      if (body && !body.querySelector('.btn-cart')) {
        body.appendChild(makeCartBtn('btn-cart'));
      }
    });
  });
})();
